import * as Sentry from "@sentry/gatsby"

Sentry.init({
  dsn: process.env.GATSBY_SENTRY_DSN,
  environment: process.env.GATSBY_ENVIRONMENT,
  release: process.env.GATSBY_SENTRY_RELEASE,
  sendDefaultPii: true,
})
